import { dataMember, required, typedArray } from 'santee-dcts';

export class Project {
    @dataMember()
    @required()
    public subProtocolId: number;

    @dataMember()
    @required()
    public zcProjectNumber: string;

    @dataMember()
    @required()
    public protocolNumber: string;

    @dataMember()
    @required()
    public sponsor: string;

    public toString() {
        return `${this.zcProjectNumber} - ${this.protocolNumber} - ${this.sponsor}`;
    }
}

export class ProjectReadModel {
    @dataMember()
    @required()
    @typedArray(Project)
    public projects: Project[];
}